export function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}

export function setCookie(
  name,
  value,
  {
    expires = null,
    maxAge = null,
    domain = null,
    path = null,
    secure = false,
    httpOnly = null,
  }
) {
  let cookie = name + '=' + value

  if (path !== null) {
    cookie += ';path=' + path
  } else {
    cookie += ';path=/'
  }

  if (expires !== null) {
    cookie += ';expires=' + expires
  }

  if (maxAge !== null) {
    cookie += ';Max-Age=' + maxAge
  }

  if (domain !== null) {
    cookie += ';Domain=' + domain
  }

  if (secure) {
    cookie += ';Secure'
  }

  if (httpOnly) {
    cookie += ';HttpOnly'
  }
  document.cookie = cookie
}

export function deleteCookie(name) {
  setCookie(name, '', { expires: new Date(null) })
}
